'use client';

import Link from '@alltrails/denali/components/Link';
import InfoDividerDot from '@alltrails/core/components/InfoDividerDot';
import { FormattedMessage } from 'react-intl';
import { useExperiments } from '@alltrails/experiments';
import type { Review } from '@alltrails/types/Review';
import ReviewVoteButton from './ReviewVoteButton';
import styles from './ReviewActionSection.module.scss';

export type ReviewActionSectionProps = {
  review: Review;
  activityLink?: {
    href: string;
    onClick?: () => void;
  };
  showVoteButton?: boolean;
};

const ReviewActionSection = ({ review, activityLink, showVoteButton: showVoteButtonProp = false }: ReviewActionSectionProps) => {
  const experiments = useExperiments();
  const isUpvoteEnabled = experiments?.['web-disco-review-upvote']?.value === 'on';
  const hasVoteLinks = !!review.votes?.links?.length;
  const showVoteButton = isUpvoteEnabled && showVoteButtonProp && hasVoteLinks;

  if (!showVoteButton && !activityLink) {
    return null;
  }

  return (
    <div className={styles.container}>
      {showVoteButton && <ReviewVoteButton review={review} />}
      {showVoteButton && activityLink && <InfoDividerDot />}
      {activityLink && (
        <Link href={activityLink.href} target="_blank" onClick={activityLink.onClick} size="md">
          <FormattedMessage defaultMessage="Show activity" />
        </Link>
      )}
    </div>
  );
};

export default ReviewActionSection;
